(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
/* País → provincias (usa data-provinces de all_country_option_tags) */
(() => {
  const countries = document.querySelectorAll('select[data-address-country]');
  if (!countries.length) return;

  countries.forEach((country) => {
    const scope = country.closest('form') || document;
    const province = scope.querySelector('select[data-address-province]');
    const wrap = scope.querySelector('[data-province-wrap]');

    const update = () => {
      if (!province) return;
      const opt = country.options[country.selectedIndex];
      let provinces = [];
      try { provinces = JSON.parse(opt ? opt.dataset.provinces || '[]' : '[]'); } catch (e) { provinces = []; }
      province.innerHTML = '';
      if (!provinces.length) { if (wrap) wrap.hidden = true; return; }
      provinces.forEach((p) => {
        const o = document.createElement('option');
        o.value = p[0];
        o.textContent = p[1];
        province.appendChild(o);
      });
      if (province.dataset.default) province.value = province.dataset.default;
      if (wrap) wrap.hidden = false;
    };

    if (country.dataset.default) country.value = country.dataset.default;
    country.addEventListener('change', update);
    update();
  });
})();

/* Confirmación antes de eliminar */
document.addEventListener('submit', (e) => {
  const f = e.target.closest('form[data-confirm]');
  if (f && !window.confirm(f.dataset.confirm)) e.preventDefault();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
/* Nota del pedido: guarda en /cart/update.js al cambiar */
document.addEventListener('change', (e) => {
  const note = e.target.closest('[data-cart-note]');
  if (!note) return;
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ note: note.value })
  }).catch(() => {});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
document.querySelectorAll('[data-tc-form]').forEach(function (form) {
  var orden = form.querySelector('[data-tc-sort]');
  if (orden) {
    orden.addEventListener('change', function () { form.submit(); });
  }
  var boton = form.querySelector('[data-tc-toggle]');
  var facets = form.querySelector('[data-tc-facets]');
  if (boton && facets) {
    boton.addEventListener('click', function () {
      var abierto = boton.getAttribute('aria-expanded') === 'true';
      boton.setAttribute('aria-expanded', abierto ? 'false' : 'true');
      facets.hidden = abierto;
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
/* Alternar entre iniciar sesión y recuperar contraseña */
(() => {
  const recover = document.getElementById('RecoverPanel');
  const login = document.getElementById('LoginPanel');
  if (!recover || !login) return;
  const show = (r) => {
    recover.hidden = !r;
    login.hidden = r;
    const first = (r ? recover : login).querySelector('input:not([type="hidden"])');
    if (first) first.focus();
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-show-recover]')) { e.preventDefault(); show(true); }
    else if (e.target.closest('[data-show-login]')) { e.preventDefault(); show(false); }
  });
  if (location.hash === '#recover') show(true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
/* Compartir producto: navigator.share con fallback a copiar enlace */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-share-btn]');
  if (!btn) return;
  e.preventDefault();
  const url = btn.dataset.shareUrl || window.location.href;
  const title = btn.dataset.shareTitle || document.title;
  if (navigator.share) {
    try { await navigator.share({ title: title, url: url }); } catch (err) { /* cancelado por el usuario */ }
    return;
  }
  try {
    await navigator.clipboard.writeText(url);
  } catch (err) {
    const tmp = document.createElement('input');
    tmp.value = url;
    document.body.appendChild(tmp);
    tmp.select();
    document.execCommand('copy');
    tmp.remove();
  }
  const label = btn.querySelector('[data-share-label]');
  if (label && !btn.dataset.shareBusy) {
    btn.dataset.shareBusy = 'true';
    const original = label.textContent;
    label.textContent = 'Enlace copiado';
    setTimeout(() => { label.textContent = original; delete btn.dataset.shareBusy; }, 2000);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
/* Product Recommendations API: fetch de la sección renderizada y swap del innerHTML */
(() => {
  const loadRecs = (host) => {
    const url = host.dataset.recsUrl;
    if (!url || host.dataset.recsLoaded) return;
    host.dataset.recsLoaded = 'true';
    fetch(url)
      .then((res) => (res.ok ? res.text() : Promise.reject(new Error('recs'))))
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const fresh = parsed.querySelector('[data-recs]');
        if (fresh && fresh.innerHTML.trim().length) {
          host.innerHTML = fresh.innerHTML;
          /* re-inicializa reveals/split-titles de tiore.js sobre el contenido nuevo */
          document.dispatchEvent(new Event('shopify:section:load'));
        } else {
          const sect = host.closest('.t-section');
          if (sect) sect.style.display = 'none';
        }
      })
      .catch(() => { /* red: silencio */ });
  };

  const initRecs = () => {
    document.querySelectorAll('[data-recs]:not([data-recs-observed])').forEach((host) => {
      host.dataset.recsObserved = 'true';
      if (!('IntersectionObserver' in window)) { loadRecs(host); return; }
      const io = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        loadRecs(host);
      }, { rootMargin: '0px 0px 500px 0px' });
      io.observe(host);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRecs);
  else initRecs();
  document.addEventListener('shopify:section:load', initRecs);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-feature"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.video-feature__frame').forEach((frame) => {
  const btn = frame.querySelector('[data-vf-play]');
  if (!btn) return;
  btn.addEventListener('click', () => {
    const videos = frame.querySelectorAll('video');
    const visible = Array.from(videos).find((v) => v.offsetParent !== null) || videos[0];
    if (!visible) return;
    videos.forEach((v) => { if (v !== visible) v.pause(); });
    visible.muted = false;
    visible.controls = true;
    visible.play();
    frame.classList.add('is-playing');
  });
});

  } catch(e) { console.error(e); }
})();
})();
